export enum UpdateFileType {
    NoChange = 0,
    New = 1,
    Remove = 2,
}